module.exports = __webpack_public_path__ + "static/jndi-35f54aa2e138fb5b0f3d065474cb0b91.png";